import { useHideChats } from 'hooks';

import { Button, Modal, T8y } from 'ui';

import style from './permitModal.module.scss';

export const PermitModal = ({ setIsPermitModalOpen }) => {
  useHideChats({ isHideOnMobile: true });

  return (
    <Modal
      header="Why Are Permits Important?"
      setIsOpen={setIsPermitModalOpen}
      classNameContent={style.modalContent}
    >
      <T8y className={style.permitText}>
        Placing a skip on a public highway or council property often
        necessitates obtaining a skip permit for safety reasons.
        <br /> <br />
        Typically, the supplier will handle the permit arrangements. However,
        some local authorities may require the skip hirer to apply for the
        permit directly. You will receive detailed guidance on this during the
        ordering process.
        <br /> <br />
        Please be aware that delivery of your skip will not proceed until the
        permit has been secured, which may take up to three business days.
      </T8y>
      <Button
        className={style.permitOkButton}
        onClick={() => setIsPermitModalOpen(false)}
      >
        <T8y color="light">Ok</T8y>
      </Button>
    </Modal>
  );
};
